import { usePlaygroundDialogStore } from "./playground-dialog-store";
import { NoInputVariables } from "./DialogTypes/NoInputVariables";
import { PlaygroundDialogType } from "./constants";
import { PromptToSaveVersion } from "./DialogTypes/PromptToSaveVersion";
import { observer } from "mobx-react-lite";

export const PlaygroundDialog = observer(
  ({ handleButtonClick }: { handleButtonClick: () => void }) => {
    const store = usePlaygroundDialogStore();

    switch (store.dialogType) {
      case PlaygroundDialogType.NoInputVariables:
        return <NoInputVariables />;
      case PlaygroundDialogType.PromptToSaveVersion:
        return <PromptToSaveVersion handleButtonClick={handleButtonClick} />;
      default:
        return null;
    }
  },
);
